'use strict';

var chunkZGQXM674_js = require('./chunk-ZGQXM674.js');
var chunkFYGG567E_js = require('./chunk-FYGG567E.js');
var chunkWNNKWDCR_js = require('./chunk-WNNKWDCR.js');
var chunkATB4Z7GO_js = require('./chunk-ATB4Z7GO.js');
var chunkGWPDT7BR_js = require('./chunk-GWPDT7BR.js');
var chunkHUKGHOBJ_js = require('./chunk-HUKGHOBJ.js');
var t = require('react');
var n = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var t__default = /*#__PURE__*/_interopDefault(t);
var n__default = /*#__PURE__*/_interopDefault(n);

var I=n__default.default.div`
  flex-direction: column;
  flex-grow: ${({$linkStyleConfig:i})=>i.resultContainerFlexGrow};
  padding: ${({$linkStyleConfig:i})=>i.containerPadding};
  display: ${({$linkStyleConfig:i,$activeIndex:d,$currentIndex:p})=>p===d?i.showContainer:i.hideContainer};
  min-height: ${({$linkStyleConfig:i})=>i.resultContainerHeight};
`,T=n__default.default.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: ${({$linkStyleConfig:i})=>`repeat(3, minmax(${i.gridSize}, 1fr))`};
  grid-template-rows: ${({$linkStyleConfig:i})=>`repeat(5, minmax(${i.minGridSize}, ${i.gridSize}))`};
  grid-gap: 10px;
  margin-top: ${({$linkStyleConfig:i})=>i.listContainerMarginTop};
  max-height: ${({$linkStyleConfig:i})=>i.listContainerHeight};
  overflow: hidden;
`,b=n__default.default.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
`,w=n__default.default.a`
  min-width: ${({$linkStyleConfig:i})=>i.listingMinWidth};
  max-width: ${({$linkStyleConfig:i})=>i.listingMaxWidth};
  margin-bottom: ${({$linkStyleConfig:i})=>i.listOptionMarginBottom};
  margin-right: ${({$linkStyleConfig:i})=>i.listOptionMarginRight};
  text-decoration: none;
`,P=n__default.default.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`,O=n__default.default.div`
  display: flex;
  flex-wrap: wrap;
  min-height: ${({$linkStyleConfig:i})=>i.gridOptionContainerHeight};
`,B=n__default.default.div`
  margin: ${({$linkStyleConfig:i})=>i.gridOptionMargin}};
`,N=n__default.default.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: ${({$linkStyleConfig:i})=>i.buttonMarginBottom};
`,M=n__default.default.div`
  display: grid;
  grid-template-columns: auto auto auto;
  gap: ${({$linkStyleConfig:i})=>i.buttonGap};
`,_=n__default.default.div`
   margin-right: ${({$linkStyleConfig:i})=>i.listTextMarginRight};
`,z=n__default.default.div`
   min-height: ${({$linkStyleConfig:i})=>i.iconSize};
   min-width: ${({$linkStyleConfig:i})=>i.iconSize};
`,V=({title:i,selectedOption:d,currentIndexValue:p,activeIndexValue:c,buttons:s})=>{let{viewType:h=chunkWNNKWDCR_js.b.LIST,links:S=[],showLinkTitle:$=!0}=d||{},{tokens:g}=chunkHUKGHOBJ_js.b(),{linkStyling:e}=chunkWNNKWDCR_js.a(g);return t__default.default.createElement(I,{$linkStyleConfig:e,$currentIndex:p,$activeIndex:c},t__default.default.createElement(chunkATB4Z7GO_js.a,{color:g.text_default_text_primary,isBold:!0},i),t__default.default.createElement(b,null,h===chunkWNNKWDCR_js.b.LIST?t__default.default.createElement(T,{$linkStyleConfig:e},S.map(r=>{let{title:o="",url:l="",suffixIcon:a=t__default.default.createElement(chunkFYGG567E_js.a,{rotateBy:315,size:"16px"})}=r||{};return t__default.default.createElement(w,{$linkStyleConfig:e,key:o,href:l,target:"_blank"},t__default.default.createElement(P,null,t__default.default.createElement(_,{$linkStyleConfig:e},t__default.default.createElement(chunkATB4Z7GO_js.a,{color:g.text_default_text_primary},o)),t__default.default.createElement(z,{$linkStyleConfig:e},a)))})):t__default.default.createElement(O,{$linkStyleConfig:e},S.map(r=>{let{title:o,url:l,imageUrl:a}=r||{};return t__default.default.createElement(B,{$linkStyleConfig:e,key:o},t__default.default.createElement(chunkZGQXM674_js.a,{title:o,url:l,imageUrl:a,device:"desktop",showLinkTitle:$,target:"_blank"}))})),(s==null?void 0:s.length)>0&&t__default.default.createElement(N,{$linkStyleConfig:e},t__default.default.createElement(M,{$linkStyleConfig:e},s.map(r=>{let{title:o,onClick:l,isSuffixIcon:a,asLink:L=!1,href:v=""}=r||{};return t__default.default.createElement(chunkGWPDT7BR_js.a,{key:o,label:o,onClick:l,variant:"brand",size:"small",underLine:!1,suffixIcon:a&&t__default.default.createElement(chunkFYGG567E_js.a,null),asLink:L,href:v,preventDefaultBehaviour:!0})})))))};

exports.a = V;
